<template>
  <div
    class="error_message"
    :class="{ warning: isWarning }"
    :style="color ? `background-color:${color}` : ''"
  >
    <div class="icon_holder">
      <slot name="icon">
        <FontAwesomeIcon :icon="['far', 'exclamation-triangle']" />
      </slot>
    </div>
    <span class="subtitle2">{{ message }}</span>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faExclamationTriangle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faExclamationTriangle);

export default {
  name: "Error",
  components: { FontAwesomeIcon },
  props: {
    message: {
      type: String,
      required: true,
    },
    isWarning: {
      type: Boolean,
      default: false,
    },
    /* Color prop to override default error or warning colors */
    color: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~include-media";
@import "../../style_variables/style_variables.scss";

.error_message {
  height: 50px;
  background-color: $red;
  display: flex;
  align-items: center;
  color: $white;
}
.warning {
  background-color: $gold;
}
.icon_holder {
  padding: 0 20px 0 24px;
  font-size: 22px;
}
</style>
